export  const styleInfo = {
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
}